import { render, staticRenderFns } from "./banner-stand-orders-filter.vue?vue&type=template&id=0b8a327c"
import script from "./banner-stand-orders-filter.vue?vue&type=script&lang=ts"
export * from "./banner-stand-orders-filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports